export default __webpack_public_path__ + "static/PFB_Transforming_Hero_COMPRESS_3-fbd96d1bc45a5caf18bf477f653d5ffa.mp4";